import { createSlice } from "@reduxjs/toolkit"
import { IDeliveryNotePlus } from '../models/DeliveryNote'
import { IUser, IUserPlus } from '../models/User'
import { IWarehouse } from '../models/Warehouse'

export interface IAuth {
  user?: IUserPlus | null
  userId?: string | null
  accessToken?: string | null
  sessionScope?: string | null
  approve?: {
    staff: IUser
    deliveryNotes: IDeliveryNotePlus[]
    warehouses: IWarehouse[]
  } | null
}

const initialState: IAuth = {
  user: null,
  userId: null,
  accessToken: null,
  sessionScope: null,
  approve: null,
}

const tokenBusinessId = (token?: string | null): string | null => {
  try {
    const body = token?.split(".")[1]
    if (!body) return null
    return JSON.parse(atob(body.replace(/-/g, "+").replace(/_/g, "/")))?.bid || null
  } catch {
    return null
  }
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authChange: (state, { payload }: { payload?: IAuth }) => {
      if (payload) {
        state.accessToken = payload?.accessToken
        state.sessionScope = payload?.sessionScope
      } else {
        state.user = null
        state.userId = null
        state.accessToken = null
        state.sessionScope = null
      }

      return state
    },
    authMe: (state, { payload }: { payload: IUser }) => {
      // Older /ord/auth/me read the business from users.current_business_id,
      // which is null for many logins; the token's bid is the real one.
      state.user = payload && !payload.currentBusinessId
        ? { ...payload, currentBusinessId: tokenBusinessId(state.accessToken) }
        : payload
      state.userId = payload?.id

      return state
    },
    authDeliveryApprove: (state, { payload }: { payload: any }) => {
      state.approve = payload
    },
  },
})

export const authReducer = authSlice.reducer

export const { authChange, authMe, authDeliveryApprove } = authSlice.actions
